import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { sitesAPI, projectsAPI } from '../../lib/api';

const Sites = () => {
  const [sites, setSites] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [sitesRes, projectsRes] = await Promise.all([
        sitesAPI.getAll(),
        projectsAPI.getAll()
      ]);
      setSites(sitesRes.data);
      setProjects(projectsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getProjectName = (projectId) => {
    const project = projects.find(p => p.id === projectId);
    return project?.name || '-';
  };

  const columns = [
    { key: 'name', label: 'Site Name' },
    { key: 'project_id', label: 'Project', render: (val) => getProjectName(val) },
    { key: 'address', label: 'Address' },
    { key: 'contact_person', label: 'Contact' },
    { key: 'phone', label: 'Phone' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    { name: 'name', label: 'Site Name', required: true, placeholder: 'Enter site name' },
    {
      name: 'project_id',
      label: 'Project',
      type: 'select',
      options: projects.map(p => ({ value: p.id, label: p.name })),
    },
    { name: 'address', label: 'Address', type: 'textarea', placeholder: 'Full address' },
    { name: 'contact_person', label: 'Contact Person', placeholder: 'Site contact' },
    { name: 'phone', label: 'Phone', placeholder: '+1-555-0000' },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'active',
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    await sitesAPI.create(data);
    fetchData();
  };

  const handleEdit = async (id, data) => {
    await sitesAPI.update(id, data);
    fetchData();
  };

  const handleDelete = async (id) => {
    await sitesAPI.delete(id);
    fetchData();
  };

  return (
    <DataTable
      title="Sites"
      description="Manage project sites and locations"
      data={sites}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Sites;
